import * as React from 'react';
import Box from '@mui/material/Box';
import LottiePlayer from '../LottiePlayer';
import plantLottie from './plant.json';

const LoadingPlant: React.FC = () => {
  const pxSize = 200;

  return (
    <Box
      sx={{
        width: { pxSize },
        height: '100%',
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
      }}
    >
      <LottiePlayer lottieJSON={plantLottie} loop={true} pxSize={pxSize} />
    </Box>
  );
};

export default LoadingPlant;
